/* eslint-disable react/jsx-key */
import { type FC, type ReactElement } from 'react';
import {
  Activities,
  Business,
  Clubs,
  Dining,
  Family,
  Parking,
  Pool,
  Pets,
  Transport,
  Wellness,
  Sustainability,
} from '.';
import { FacilitiesSelectProps } from './types';

const FacilitiesSelect: FC<FacilitiesSelectProps> = ({ name, ...props }) => {
  const icons = new Map<string, ReactElement>([
    ['dining', <Dining {...props} />],
    ['clubs', <Clubs {...props} />],
    ['parking', <Parking {...props} />],
    ['pools', <Pool {...props} />],
    ['pets', <Pets {...props} />],
    ['family', <Family {...props} />],
    ['transport', <Transport {...props} />],
    ['wellness', <Wellness {...props} />],
    ['activities', <Activities {...props} />],
    ['business', <Business {...props} />],
    ['sustainability', <Sustainability {...props} />],
  ]);
  return icons.get(name) || <></>;
};

export default FacilitiesSelect;
